module.exports = __webpack_public_path__ + "static/persona-2-90866084c5988a440992d0febb69d14c.jpg";